"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ceilDate = exports.floorDate = exports.dateAdd = exports.daysAgo = void 0;
function daysAgo(days) {
    return new Date(Date.now() - 1000 * 3600 * 24 * days);
}
exports.daysAgo = daysAgo;
/**
 * @see https://stackoverflow.com/a/1214753/1958334
 */
function dateAdd(date, unit, amount) {
    let ret = new Date(date);
    const checkRollover = () => {
        if (ret.getDate() != date.getDate())
            ret.setDate(0);
    };
    switch (unit) {
        case 'year':
            ret.setFullYear(ret.getFullYear() + amount);
            checkRollover();
            break;
        case 'quarter':
            if (amount > 4)
                throw new Error(`Invalid quarter: ${amount}`);
            ret.setMonth(ret.getMonth() + 3 * amount);
            checkRollover();
            break;
        case 'month':
            if (amount > 12)
                throw new Error(`Invalid month: ${amount}`);
            ret.setMonth(ret.getMonth() + amount);
            checkRollover();
            break;
        case 'week':
            ret.setDate(ret.getDate() + 7 * amount);
            break;
        case 'day':
            ret.setDate(ret.getDate() + amount);
            break;
        case 'hour':
            ret.setTime(ret.getTime() + amount * 3600000);
            break;
        case 'minute':
            ret.setTime(ret.getTime() + amount * 60000);
            break;
        case 'second':
            ret.setTime(ret.getTime() + amount * 1000);
            break;
        default:
            // Probably unreachable
            throw new Error(`Incorrect unit: ${unit}`);
    }
    return ret;
}
exports.dateAdd = dateAdd;
/**
 * "Floors" date. Useful if you work with date ranges.
 * Beware: UTC only
 * denominator allows you to "floor" it to, for example a 15-minute interval (or to 15-year)
 */
function floorDate(date, unit, denominator = 1) {
    let year = date.getUTCFullYear();
    let month = date.getUTCMonth();
    let dayOfMonth = date.getUTCDate();
    let hour = date.getUTCHours();
    let minute = date.getUTCMinutes();
    let second = date.getUTCSeconds();
    switch (unit) {
        case 'year':
            year = Math.floor(year / denominator) * denominator;
            return new Date(Date.UTC(year, 0, 1, 0, 0, 0, 0));
        case 'quarter':
            month = Math.floor(month / 3 / denominator) * denominator * 3;
            return new Date(Date.UTC(year, month, 1, 0, 0, 0, 0));
        case 'month':
            month = Math.floor((month + 1) / denominator) * denominator - 1;
            return new Date(Date.UTC(year, month, 1, 0, 0, 0, 0));
        case 'dayOfMonth':
            dayOfMonth = Math.floor(dayOfMonth / denominator) * denominator;
            return new Date(Date.UTC(year, month, dayOfMonth, 0, 0, 0, 0));
        case 'hour':
            hour = Math.floor(hour / denominator) * denominator;
            return new Date(Date.UTC(year, month, dayOfMonth, hour, 0, 0, 0));
        case 'minute':
            minute = Math.floor(minute / denominator) * denominator;
            return new Date(Date.UTC(year, month, dayOfMonth, hour, minute, 0, 0));
        case 'second':
            second = Math.floor(second / denominator) * denominator;
            return new Date(Date.UTC(year, month, dayOfMonth, hour, minute, second, 0));
        default:
            // Should be unreachable
            throw new Error(`Incorrect unit: ${unit}`);
    }
}
exports.floorDate = floorDate;
/**
 * "Ceils" date. Useful if you work with date ranges.
 * Beware: UTC only
 * denominator allows you to "ceil" it to, for example a 15-minute interval (or to 15-year)
 *
 * Algorithm is follows: do "floorDate". If result is the same, as input, we're good.
 * If not, we're short by `denominator` of `unit`'s
 *
 * time changes may lead to an added or subtracted hour
 */
function ceilDate(date, unit, denominator = 1) {
    const floored = floorDate(date, unit, denominator);
    if (floored.getTime() === date.getTime()) {
        return floored;
    }
    let added = dateAdd(floored, unit === 'dayOfMonth' ? 'day' : unit, denominator);
    if (['year', 'quarter', 'month', 'dayOfMonth'].includes(unit)) {
        if (added.getUTCHours() === 23) {
            added = new Date(added.getTime() + 3600 * 1000);
        }
        else if (added.getUTCHours() === 1) {
            added = dateAdd(added, 'hour', -1);
        }
    }
    return added;
}
exports.ceilDate = ceilDate;
//# sourceMappingURL=index.js.map